import React, { Component } from 'react';
import Logo from '../img/logo.svg';
import Logo2 from '../img/dondeahorro.svg';
import { Navbar, Nav, NavItem } from 'react-bootstrap';
import { NavLink } from "react-router-dom";

export default class Header extends Component {
	render() {
		return (
			<header className="Header">
				<Navbar collapseOnSelect>
					<Navbar.Header>
						<Navbar.Brand>
							<a className="navbar-brand" href="https://www.argentina.gob.ar/produccion">
								<img src={Logo} height="50" alt="" />
							</a>
						</Navbar.Brand>	
					{/*}
					{this.props.step !== 0 && (
						<Navbar.Brand>
							<a className="navbar-brand" href="https://www.argentina.gob.ar/produccion">
								<img src={Logo2} height="30" alt="" />
							</a>
						</Navbar.Brand>
					)}
				*/}
					{this.props.step !== 0 && (<Navbar.Toggle className="pull-right m-r-1" />)}
					</Navbar.Header>
					
					<Navbar.Collapse> 
						<Nav className="right-desktop">
							{this.props.step !== 0 && (
								<NavItem href="/" className="font-bold" onClick={this.props.resetApp}>
									¿DÓNDE AHORRO?
								</NavItem>
							)}
							{this.props.step !== 0 && (
								<li>
									<NavLink 
									to="/sobre-esta-pagina"
									>SOBRE ESTE SITIO</NavLink>
								</li>
							)}
							{this.props.step === 0 && (
								<a href="https://mi.argentina.gob.ar" className="btn btn-success hidden-xs">
									<i className="fa fa-user" /> &nbsp; Mi Argentina
								</a>
							)}
						</Nav>
					</Navbar.Collapse>
				</Navbar>
			</header>
		);
	}
}
